import type { ChromecastSession } from '@dicetechnology/dice-doris';

import type { DiceCustomData } from '../types';

export const getChromecastSession = (customData: DiceCustomData): ChromecastSession => {
    if (customData.chromecastSession) {
        return customData.chromecastSession;
    }

    if (customData.chromecastSessionSerialized) {
        return JSON.parse(customData.chromecastSessionSerialized);
    }

    throw new Error('No session in payload!');
};
